import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";

import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
import { BackButton } from "../../../Utils/FormInputs/BackButton";
import TextField from "../../../Utils/FormInputs/TextField";
import Label from "../../../Utils/FormInputs/Label";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useMuiPagination } from "../../../Containers/Dasboard/DashboardTables";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPagination,
  MuiPaper,
} from "../../../Utils/Tables/CustomTable";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";

import { titleCase } from "../../../Utils/titleCaseFunction";
import { dateConvert } from "../../../Utils/ConvertDate";
import { LoadingGif } from "../../../Utils/Loader";
import { ErrorMessage } from "../../../Utils/styledComponents";

const headData = [
  { id: "date", label: "Date" },
  { id: "product", label: "Product" },
  { id: "batch", label: "Batch #" },
  { id: "reason", label: "Reason" },
  { id: "quantity", label: "Quantity" },
  { id: "unit_cost", label: "Unit Cost (USh)" },
  { id: "total_cost", label: "Total Cost (USh)" },
  { id: "adjusted_by", label: "Adjusted By" },
];

const DamagedGoodsReport = () => {
  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    // setPage,
  } = useMuiPagination();

  const today = new Date().toISOString().split("T")[0];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [totalDamagedQty, setTotalDamagedQty] = useState(0);
  const [totalDamagedCost, setTotalDamagedCost] = useState(0);

  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [Page, setPage] = useState(0);

  useEffect(() => {
    setFromDate(today);
    setToDate(today);
  }, []);

const handleRowsPerPageChange = (event) => {
  handleChangeRowsPerPage(event);
  setPage(0);
};
  const fetchData = () => {
    setLoading(true);

    axios
      .get(`${config.epharmUrl}/Creport/damage_list`, {
        params: {
          page: page + 1,
          search: search || null,
          per_page: rowsPerPage||10,   // ✅ ADD THIS

          start_date: fromDate || null,
          end_date: toDate || null,
        },
      })
      .then((res) => {
        const resp = res.data;

        setData(resp.adjustments || []);
        setTotalCount(resp.total_count || 0);
        setTotalPages(resp.total_pages || 0);

        setTotalDamagedQty(resp.total_damaged_quantity || 0);
        setTotalDamagedCost(resp.total_damaged_cost || 0);

        setLoading(false);
      })
      .catch((err) => {
        ErrorMessage(err);
        setLoading(false);
      });
  };

  // ONLY FETCH ON DEPENDENCY CHANGE
  // useEffect(() => {
  //   fetchData();
  // }, [page, search, fromDate, toDate]);
useEffect(() => {
  fetchData();
}, [page, search, fromDate, toDate, rowsPerPage]);
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(0); // triggers useEffect
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "from_date") setFromDate(value);
    if (name === "to_date") setToDate(value);
  };

  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, data.length);

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Damaged Goods Report"
        heading="Reports"
        subHeading="Damaged Goods"
        link="/reports"
      />

      <div className="general-ledger-header mb-3">
        <BackButton text="Reports" to="/allreports" />

        <form onSubmit={handleSearchSubmit}>
          <Form.Group as={Row}>
            <Col sm={4}>
              <Label name="From" />
              <TextField
                type="date"
                value={fromDate}
                onChange={handleDateChange}
                name="from_date"
              />
            </Col>

            <Col sm={4}>
              <Label name="To" />
              <TextField
                type="date"
                value={toDate}
                onChange={handleDateChange}
                name="to_date"
              />
            </Col>

            <Col sm={3}>
              <Label name="Search" />
              <TextField
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Product, batch..."
              />
            </Col>

            <Col sm={1} className="d-flex align-items-end">
              <button className="btn btn-sm pharmacy-btn-outline">
                Filter
              </button>
            </Col>
          </Form.Group>
        </form>
      </div>

      {/* TOTALS */}
      <div className="alert alert-warning mb-4">
        <strong>Total Damaged Quantity:</strong>{" "}
        {totalDamagedQty.toFixed(2)} units |{" "}
        <strong>Total Loss:</strong>{" "}
        USh{" "}
        {totalDamagedCost.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}
      </div>

      <MuiPaper>
        <EnhancedTableToolbar title="Damaged Goods List" />

        <TableContainer>
          <Table size="medium">
            <EnhancedTableHead headCells={headData} />

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <LoadingGif />
                  </TableCell>
                </TableRow>
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No damaged goods found.
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {dateConvert(item.date_created)}
                    </TableCell>
                    <TableCell>
                      {titleCase(item.product_name)}
                    </TableCell>
                    <TableCell>{item.batch_id || "-"}</TableCell>
                    <TableCell>
                      {titleCase(item.reason)}
                    </TableCell>
                    <TableCell align="right">
                      {item.quantity}
                    </TableCell>
                    <TableCell align="right">
                      {item.unit_cost.toLocaleString()}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ color: "#c4495c", fontWeight: "bold" }}
                    >
                      {item.total_cost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell>
                      {titleCase(item.adjusted_by)}
                    </TableCell>
                  </TableRow>
                ))
              )}

              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 40 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>

          {/* PAGINATION */}
          <MuiPagination
            data={data}
            total_count={totalCount}
            total_pages={totalPages}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            isTotalCount={true}   // ✅ ADD THIS
            // handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangeRowsPerPage={handleRowsPerPageChange}

            rows={[10, 25, 50, 100]}
            colSpan={8}
          />
        </TableContainer>
      </MuiPaper>
    </div>
  );
};

export default DamagedGoodsReport;